import api from '@/helpers/api'

const API_READ=`/api/member-tier`
const API_CHECK=`${API_READ}/member-tiering/`

export default {
  namespaced:true,
  state: {
    status: '',
    ShowMemberTier:[],
    meta:{
      page:1,
      limit:10,
      total:1
    },
    filter: {}
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { ShowMemberTier }) {
      state.ShowMemberTier = [...ShowMemberTier]
    },
    recalculate(state, { ShowMemberTier }) {
      state.ShowMemberTier = [...ShowMemberTier]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    reset_meta(state) {
        state.meta = {
            limit: 10,
            page: 1,
            total: 1,
        }
    }
  },
  actions: {    
    recalculate({commit},id){
      commit('request');
      return new Promise((resolve, reject) => {
        api.request('post', `${API_CHECK}${id}`)
          .then((result) => {
              commit('success')
              return resolve(result.data.data)
          }).catch((err) => {
              commit('error', {message: err})
              return reject();
          });
      });
  },
    read({commit, state}){
        commit('request');
        const {meta} = state
        const {filter} = state
        const {search} = state

        return new Promise((resolve, reject) => {
            api.request('get', `${API_READ}${state.filter.tier_id}`, {meta, filter, search})
            .then((result) => {
                commit('success')
                commit('read',{ShowMemberTier:result.data.data})
                commit('switch_page',{meta:{...result.data.meta}})
                return resolve(result)
            }).catch((err) => {
                commit('error', {message: err})
                return reject();
            });
        });
    }
  },
  getters : {
    ShowMemberTier: ()=>state => state.ShowMemberTier,
  }
}
